import { useContext } from 'react'
import BootstrapDataContext from '../../context/BootstrapDataContext'

export default function useExtendStayBooking() {
  const {
    mostRecentBooking: { current }
  } = useContext(BootstrapDataContext)
  const extendStayTrip = current?.extendStayTrip
  return extendStayTrip
    ? {
        travelEndDateTime: extendStayTrip.travelEndDateTime,
        cityName: extendStayTrip.cityName,
        hotelID: extendStayTrip.hotelID,
        numRooms: extendStayTrip.numRooms,
        title: extendStayTrip.title
      }
    : null
}
